import { useHemiShallow } from "@/stores/hemi";
import { useEffect } from "react";
import usePromptCollection from "./usePromptCollection";

interface UseHemiPopupProps {
	disabled?: boolean;
}

function useHemiPopup({ disabled = false }: UseHemiPopupProps = {}) {
	const { hemiAiDisclaimer } = usePromptCollection();
	const isPopupOpen = useHemiShallow((state) => state.isPopupOpen);
	const showPopup = useHemiShallow((state) => state.showPopup);
	const markAsShown = useHemiShallow((state) => state.markAsShown);
	const shouldShowPopup = useHemiShallow((state) => state.shouldShowPopup);

	useEffect(() => {
		if (shouldShowPopup() && !disabled) {
			let frameId: number;
			const showPopupFrame = () => {
				frameId = requestAnimationFrame(() => {
					showPopup();
				});
			};
			showPopupFrame();
			return () => {
				if (frameId) {
					cancelAnimationFrame(frameId);
				}
			};
		}
	}, [shouldShowPopup, showPopup, disabled]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (isPopupOpen) hemiAiDisclaimer(markAsShown);
	}, [isPopupOpen, hemiAiDisclaimer]);
}

export default useHemiPopup;
